module.exports = __webpack_public_path__ + "assets/img/pv01.0bcdc9f3.png";